import { IdNameList } from "../../../../../api/services/common/models";
import { AddDeliverableType } from "../../../../../helpers/constants";
import { KeyValue, LabelValue } from "../../../../../helpers/types/common";

export const CreateClientActivitiesFormKeys = {
  activityType: "activityType",
  modality: "modality",
  topic: "topicName",
  activityStatus: "activityStatus",
  units: "units",
  measurement: "measurement",
  candidateStatuses: "candidateStatuses",
  tableBody: "tableBody",
  tableRow: "tableRow",
  tableFooter: "tableFooter",
  tablePagination: "tablePagination",
} as const;

export const CreateClientDeliverablesFormKeys = {
  name: "name",
  deliverableType: "deliverableType",
  units: "units",
  measurements: "measurements",
  activityTypes: "activityTypes",
  tableBody: "tableBody",
  tableRow: "tableRow",
  tableFooter: "tableFooter",
  tablePagination: "tablePagination",
} as const;

export interface CreateClientActivitiesAndDeliverablesProps {
  rows: CreateClientActivitiesRowValue[];
  deliverableRows: CreateClientDeliverablesRowValue[];
  onCreateActivityClick: () => void;
  successHandler: () => void;
  successHandlerDeliverables: () => void;
  isView?: boolean;
  onCreateDeliverableClick: () => void;
}

export interface CreateClientActivitiesRowValue {
  id: string;
  activityType: IdNameList;
  modalities: string;
  topicName: string;
  activityStatus: string;
  units: string;
  measurement: string;
  candidateStatus: string;
  [key: string]: any;
}

export interface CreateClientDeliverablesRowValue {
  id: string;
  name: string | null;
  deliverableType: string;
  units: string;
  measurement: string;
  activityTypes: ActivityType[];
  [key: string]: any;
}

export interface ActivityType {
  id: string;
  name: string | null;
}

export interface DeliverableUniqueFiltersTypes {
  activityTypes: LabelValue[];
  deliverableType: LabelValue[];
  units: LabelValue[];
}

export interface UpdateDeliverablesFormProps {
  units: string;
  measurementMinute: string;
  measurementOther: number | null;
}

export const UpdateDeliverablesFormKeys = {
  units: "units",
  measurementMinute: "measurementMinute",
  measurementOther: "measurementOther",
} as const;

export const CreateActivityDefaultFormKeys = {
  units: "units",
  measurementMinute: "measurementMinute",
  measurementOther: "measurementOther",
  measurement: "measurement",
  mesurementName: "mesurementName",
} as const;

export const CreateActivityGeneralFormKeys = {
  candidateStatuses: "candidateStatuses",
  activityType: "activityType",
  modality: "modality",
  topic: "topic",
  deliverables: "deliverables",
  activityStatus: "activityStatus",
  triggerBilling: "triggerBilling",
  lastContactDate: "lastContactDate",
  triggerTouch: "triggerTouch",
} as const;

export interface EditActivityValueProps
  extends Omit<CreateActivityGeneralProps, "activityType">,
    CreateActivityDefaultProps {
  activityType: IdNameList;
}

export interface CreateActivityGeneralProps {
  candidateStatuses: string[];
  activityType: string;
  modality: string[];
  topic: KeyValue;
  deliverables: string[];
  activityStatus: string;
  triggerBilling: boolean;
  lastContactDate: boolean;
  triggerTouch: boolean;
}
export interface CreateActivityDefaultProps {
  units: string;
  measurementMinute: string;
  measurementOther: number | null;
}

export const CreateDeliverablesFormKeys = {
  addDeliverableType: "addDeliverableType",
  deliverableType: "deliverableType",
  name: "name",
  units: "units",
  measurementMinute: "measurementMinute",
  measurementOther: "measurementOther",
} as const;

export interface CreateDeliverablesFormProps {
  addDeliverableType: AddDeliverableType;
  deliverableType: string;
  name: KeyValue;
  units: string;
  measurementMinute: string;
  measurementOther: number | null;
}

export interface ExistingDeliverableFilterFormProps {
  deliverableType: string;
  name: string;
  units: string;
}

export const ExistingDeliverableFormKeys = {
  deliverableType: "deliverableType",
  units: "units",
  measurements: "measurements",
  isSelected: "isSelected",
  id: "id",
  name: "name",
  unitName: "unitName",
  deliverableTypeName: "deliverableTypeName",
} as const;

export interface ExistingDeliverablesType {
  deliverableType: string;
  units: string;
  measurement: number;
  isSelected: boolean;
  id: string;
  name: string;
  unitName: string;
  deliverableTypeName: string;
  [key: string]: any;
}

export interface CreateClientDeliverablesTabProps {
  rows: CreateClientDeliverablesRowValue[];
  tableRef: React.RefObject<any>;
  isView: boolean;
  control: any;
  uniqueFilters: DeliverableUniqueFiltersTypes;
  filteredResults: CreateClientDeliverablesRowValue[];
  deleteAction: (id: string) => void;
  onDeliverableViewClick: (
    data: CreateClientDeliverablesRowValue,
    isEdit?: boolean,
  ) => void;
}

export interface CreateClientActivitiesTabProps {
  rows: CreateClientActivitiesRowValue[];
  tableRef: React.RefObject<any>;
  isView: boolean;
  control: any;
  uniqueFilters: ActivityAndDeliverablesFiltersTypes;
  filteredResults: CreateClientActivitiesRowValue[];
  deleteAction: (id: string) => void;
  onActivityViewClick: (
    data: CreateClientActivitiesRowValue,
    isEdit?: boolean,
  ) => void;
}

export interface ActivityAndDeliverablesFiltersTypes {
  activityType: LabelValue[];
  modality: LabelValue[];
  units: LabelValue[];
}

export interface ViewActivityResponse {
  id?: string;
  activityType: IdNameList;
  modalities: string[];
  topicName: string;
  activityStatus: string;
  units: string;
  candidateStatuses: string[];
  triggerBilling: boolean;
  countsTowardsLastContactDate: boolean;
  triggerTouchPointSurvey: boolean;
  measurement: string;
  deliverables: {
    id: string;
    name: string;
  }[];
}
